module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    },
    on: {
      "after-leave": _vm.doDestroy
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopper),
      expression: "showPopper"
    }],
    staticClass: "rt-autocomplete-suggestion el-autocomplete-suggestion el-popper",
    class: {
      'is-loading': !_vm.parent.hideLoading && _vm.parent.loading
    },
    style: ({
      width: _vm.dropdownWidth
    }),
    attrs: {
      "role": "region"
    }
  }, [_c('el-scrollbar', {
    attrs: {
      "tag": "ul",
      "wrap-class": "el-autocomplete-suggestion__wrap",
      "view-class": "el-autocomplete-suggestion__list"
    }
  }, [(!_vm.parent.hideLoading && _vm.parent.loading) ? _c('li', [_c('i', {
    staticClass: "el-icon-loading"
  })]) : _vm._t("default")], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00fc5cce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/element-ui/packages/autocomplete/src/autocomplete-suggestions.vue
// module id = 2059
// module chunks = 137